export default __webpack_public_path__ + "static/media/ooki-web-preview.f40c0318.png";